import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { InViewportModule } from 'ng-in-viewport';
import { PaymentSipModule } from '../payment-sip/payment-sip.module';

import { PaymentSipDialogComponent } from './payment-sip-dialog-btn.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [PaymentSipDialogComponent],
  exports: [PaymentSipDialogComponent],
  imports: [
    CommonModule,
    PaymentSipModule,
    MatButtonModule,
    MatDialogModule,
    InViewportModule,
    SharedModule
  ]
})
export class PaymentSipDialogBtnModule { }
